import { format } from 'date-fns';

import { Box, Grid } from '@simplywallst/ui-core';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import {
  getMarketInsightsQueryKey,
  useLatestArticles,
} from '@/hooks/useLatestArticles';
import { useIsMobileScreen } from '@/hooks/useMedia';

import { ArticleFeedItem, ArticleSummary } from '@/components/ArticleSummary';

import { RecentInsightsSkelecton } from './Skeleton';

import { SidebarContainer, Wrapper } from './styled';

const RecentArticles = () => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  const { data, isFetching } = useLatestArticles(getMarketInsightsQueryKey());
  const [highlight = null, secondaryArticle = null] = data?.articles ?? [];

  if (!highlight) {
    return null;
  }

  return (
    <Wrapper>
      <Box
        position="relative"
        marginBottom="x3"
        paddingBottom="x2"
        paddingTop="x2"
        marginBottomMd="x0"
        paddingBottomMd="x0"
        paddingTopMd="x0"
        backgroundColor={isMobileScreen ? 'noir' : 'transparent'}
      >
        <SidebarContainer>
          <Grid paddingRight="x2" paddingLeft="x2" paddingMd="x0">
            {isFetching ? (
              <RecentInsightsSkelecton />
            ) : (
              <>
                <ArticleSummary
                  slug={highlight.slug}
                  title={highlight.title}
                  excerpt={highlight.excerpt}
                  imageUrl={highlight.coverURL}
                  publishedDate={format(
                    new Date(highlight.created),
                    'MMMM yyyy'
                  )}
                  author={highlight.author?.name}
                  authorAvatarUrl={highlight.author?.photoURL}
                  authorSlug={highlight.author?.slug}
                />
                {secondaryArticle && (
                  <ArticleFeedItem
                    title={secondaryArticle.title}
                    imageUrl={secondaryArticle.coverURL}
                    slug={secondaryArticle.slug}
                  />
                )}
              </>
            )}
          </Grid>
        </SidebarContainer>
      </Box>
    </Wrapper>
  );
};

export default RecentArticles;
